import { useMemo } from "react";
import HiddenPageForm from "../HiddenPageForm";
import { HiddenPageProps } from "../HiddenPageSingle";
import { QuoteSelection } from "../../../models/Quote";
import enumToOptions from "../../../utils/enumToOptions";

export default function HiddenQuoteSelect({register, setValue, watch}: HiddenPageProps) {
  const quoteSelectionOptions = useMemo(() => enumToOptions(QuoteSelection), []);

  const schema = [
    {
      key: "quoteSelection",
      label: "Quote Selection",
      type: "select",
      options: quoteSelectionOptions,
    },
  ];

  return (
    <HiddenPageForm 
      title={"Quote Selection"}
      description={"Fill out the quote selection details to prefill for this page."}
      register={register} 
      setValue={setValue}
      watch={watch}
      schema={schema} 
    />
  );
}